<template>
  <div class="c-admin-manufacturersTable">
    <div
      class="c-admin-manufacturersTable__heading o-grid o-grid--gutter-normal o-grid--align-items-center o-grid--no-overflow"
    >
      <div class="o-grid__group">
        <div class="o-grid__item">
          <h3 class="o-heading o-heading--bold o-heading--size-2">
            {{ translationsManufacturersTable.headline || "" }}
          </h3>
        </div>
        <div class="o-grid__item o-grid__item--grow-0">
          <button class="o-button" @click="showManufacturerCreate = true">
            {{ translationsManufacturersTable.addManufacturer || "" }}
          </button>
        </div>
      </div>
    </div>
    <div class="o-grid">
      <div class="o-grid__group">
        <div class="o-grid__item o-grid__item--12">
          <div
            class="c-admin-manufacturersTable__head o-grid o-grid--gutter-normal o-grid--align-items-center o-grid--no-overflow"
          >
            <div class="o-grid__group">
              <div class="o-grid__item o-grid__item--6">
                <span class="c-admin-manufacturersTable__head-text">{{
                  translationsCustom.name || ""
                }}</span>
              </div>
              <div class="o-grid__item o-grid__item--3">
                <span class="c-admin-manufacturersTable__head-text">{{
                  translationsCustom.selectableForEndUsersHeadline || ""
                }}</span>
              </div>
              <div class="o-grid__item o-grid__item--3">
                <!-- <span class="c-admin-manufacturersTable__head-text">{{
                  translationsCustom.actions || ""
                }}</span> -->
              </div>
            </div>
          </div>
        </div>
        <div
          class="o-grid__item o-grid__item--12"
          v-for="manufacturer in manufacturersAll"
          :key="manufacturer.id"
          :tabindex="activeItem === manufacturer.id ? '' : 0"
          @keyup.enter="setActiveItem(manufacturer.id)"
          @click="setActiveItem(manufacturer.id)"
        >
          <CallCenterADMINmanufacturer
            :manufacturer="manufacturer"
            :active="activeItem === manufacturer.id"
          ></CallCenterADMINmanufacturer>
        </div>
      </div>
    </div>
    <CallCenterADMINmanufacturerModal
      :showManufacturerCreate="showManufacturerCreate"
      @close="showManufacturerCreate = false"
      id="0"
    ></CallCenterADMINmanufacturerModal>
    <CallCenterADMINmanufacturerDelete
      :showManufacturerDelete="showManufacturerDelete"
      @close="showManufacturerDelete = false"
      id="0"
    ></CallCenterADMINmanufacturerDelete>
    <CallCenterADMINmodelModal
      :showModelCreate="showModelCreate"
      @close="showModelCreate = false"
      id="0"
    ></CallCenterADMINmodelModal>
    <CallCenterADMINmodelDelete
      :showModelDelete="showModelDelete"
      @close="showModelDelete = false"
      id="0"
    ></CallCenterADMINmodelDelete>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CallCenterADMINmanufacturer from "@/components/Admin/admin-manufacturer.vue";
import CallCenterADMINmanufacturerModal from "@/components/Admin/admin-manufacturerModal.vue";
import CallCenterADMINmanufacturerDelete from "@/components/Admin/admin-manufacturerDelete.vue";
import CallCenterADMINmodelModal from "@/components/Admin/admin-modelModal.vue";
import CallCenterADMINmodelDelete from "@/components/Admin/admin-modelDelete.vue";
export default {
  name: "c-admin-manufacturersTable",
  data() {
    return {
      selected: "producers",
      activeItem: 0,
      showManufacturerCreate: false,
      showManufacturerDelete: false,
      showModelCreate: false,
      showModelDelete: false
    };
  },
  components: {
    CallCenterADMINmanufacturer,
    CallCenterADMINmanufacturerModal,
    CallCenterADMINmanufacturerDelete,
    CallCenterADMINmodelModal,
    CallCenterADMINmodelDelete
  },
  computed: {
    ...mapState("manufacturers", {
      manufacturersAll: "all",
      manufacturerToEdit: "manufacturerToEdit"
    }),
    ...mapState("translations", {
      translationsManufacturersTable: "manufacturersTable",
      translationsCustom: "custom"
    })
  },
  methods: {
    setActiveItem(itemId) {
      if (this.activeItem !== itemId) {
        this.activeItem = itemId;
      }
    }
  }
};
</script>

<style lang="scss">
.c-admin-manufacturersTable {
  &__heading {
    margin-bottom: 20px;
  }
  &__head {
    background-color: $s-cp-neutral-white;
    margin-bottom: 3px;
    border: 1px solid $s-cp-neutral-600;
    min-height: 46px;
    padding: 0 10px;
    &-text {
      @include setStyles("13", $s-typography-sizes);
      font-weight: 700;
    }
  }
}
</style>
